import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { Icons } from '../../font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { DOMUtils } from '@/utils/dom_utils';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import CommonButton from '../CommonButton.vue';

const labelLeft = 20;

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSelector',
  props: {
    hideBorder: { type: Boolean, required: false },
    emptyMessage: { type: String, required: false },
    customSubtitle: { type: String, required: false },
    initialSelection: { type: Number, required: false },
    size: { type: String, required: false },
    zIndex: { type: Number, required: false },
    state: { type: String, required: false },
    supportingText: { type: String, required: false },
    icon: { type: Object, required: false },
    clearOption: { type: Object, required: false },
    options: { type: Array, required: true },
    noOptionsMessage: { type: String, required: false },
    button: { type: Object, required: false },
    deprioritizeTitle: { type: Boolean, required: false }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose }) {

const quadrant = ref({
  isSuperior: false,
  isLeft: false,
});

const props = __props;

const selected = ref<number | null>(props.initialSelection ?? null);
const contextMenuElem = ref<HTMLDivElement>();
const labelElem = ref<HTMLElement | null>(null);
const currentLabelSize = ref(0);
const floatOn = computed(() => isFocused.value && selected !== null);
const state = computed(() => props.state ?? 'default');
const isShowingContextMenu = ref(false);
const isFocused = ref(false);
const isHovered = ref(false);
const maxHeight = ref(0);
const isMobile = ref(false);



function getState() {
  if (isFocused.value) {
    return "focused";
  }
  if (isHovered.value && state.value != "disabled") {
    return "hovered";
  }
  return `${state.value}`;
}

function getTitle(selected:number | null):string | null {
  if (selected === null) return null;
  if (props.deprioritizeTitle) {
    if (props.customSubtitle) return `${props.customSubtitle}`;
    if (props.customSubtitle !== undefined) return '';
    return props.options?.at(selected)?.subtitle ?? null;
  }
  return props.options?.at(selected)?.title ?? null
}

function getSubTitle(selected:number | null):string | null {
  if (selected === null) return null;
  if (props.deprioritizeTitle) return props.options?.at(selected)?.title ?? null;
  if (props.customSubtitle !== undefined) return '';
  return props.options?.at(selected)?.subtitle ?? null;
}

__expose({
  clearSelection: () => {
    selected.value = null;
  },
  getSelected: () => {
    return selected.value;
  },
  setSelected: (value: number | null) => {
    selected.value = value;
  }
});

let resizeObserver: ResizeObserver | null = null;
onMounted(() => {
  window.addEventListener('resize', update);
  window.addEventListener('click', () => {
    if (!isMouseOver.value) isShowingContextMenu.value = false;
    if (!isShowingContextMenu.value) isFocused.value = false;
  });
  resizeObserver = new ResizeObserver(update);
  resizeObserver.observe(contextMenuElem.value!);
});

onUnmounted(() => {
  resizeObserver?.disconnect();
});

function update() {
  const contextMenuHeight = contextMenuElem.value?.getBoundingClientRect().height ?? 0;
  quadrant.value = DOMUtils.detectQuadrant(contextMenuElem.value!);
  maxHeight.value = DOMUtils.getDistanceToTopBottom(contextMenuElem.value!) - 5 - contextMenuHeight;
  isMobile.value = window.innerWidth < 836;
  currentLabelSize.value = labelElem.value?.offsetWidth ?? 0;
}

const isMouseOver = ref(false);


const __returned__ = { quadrant, props, selected, contextMenuElem, labelElem, currentLabelSize, labelLeft, floatOn, state, isShowingContextMenu, isFocused, isHovered, maxHeight, isMobile, getState, getTitle, getSubTitle, get resizeObserver() { return resizeObserver }, set resizeObserver(v) { resizeObserver = v }, update, isMouseOver, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon }, CommonButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})